import React from 'react';
import { FormField } from '../../../types/formBuilder';

interface TextInputProps {
  field: FormField;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  disabled?: boolean;
}

export const TextInput: React.FC<TextInputProps> = ({
  field,
  value,
  onChange,
  error,
  onFocus,
  onBlur,
  disabled = false
}) => {
  const baseClasses = "w-full bg-elevated border border-subtle rounded-lg px-4 py-3 text-th-primary placeholder-th-tertiary focus:border-brand focus:outline-none transition-all";
  const errorClasses = error ? "border-status-error focus:border-status-error" : "";

  return (
    <input
      type={field.type}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      onFocus={onFocus}
      onBlur={onBlur}
      placeholder={field.placeholder}
      required={field.required}
      disabled={disabled}
      className={`${baseClasses} ${errorClasses}`}
    />
  );
};